module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_BlackMatted_MockedUp.e4f5d1ed.jpg";